module.exports = __webpack_public_path__ + "img/blood-pressure-log_B09M2LPFDD.9ad56559.jpg";